import { FC } from 'react';

type SvgProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  color?: string;
};

const UploadTraySVG: FC<SvgProps> = ({ className, width = 18, height = 18, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 13V14C3 14.5523 3.44772 15 4 15H14C14.5523 15 15 14.5523 15 14V13"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11V3M9 3L5.5 6.5M9 3L12.5 6.5"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadTraySVG;
